import React from 'react';
import { col_image,col_large } from "../../Fonctions.js";
import sarcomes from '../../Resources/sarcome.png';


function Cause({className}) {
    return (
        <section className={`bandeau ${className}`}>
    <div className='row'>
        <div className={`col-xs-12 ${col_large}`}>
            <h1>Notre cause autour des sarcomes</h1>
            <p>Les sarcomes sont des tumeurs rares représentant 15% des cancers de l’enfant et des jeunes adultes.</p>
            <p>Ce sont des cancers agressifs touchant les tissus mous du corps, les viscères ou les os.</p>
            <p>Ils ont bénéficié de peu d’avancées thérapeutiques au cours des dernières décennies.</p>
        </div>
        <div className={`col-xs-12 ${col_image}`}>
            <img className="img-fluid" src={sarcomes} alt='Infographie sarcomes' />
        </div>
    </div>
</section>

)}

export default Cause;